import { createRouter, createWebHistory } from 'vue-router'

const EditorLoader = () => import('@/views/EditorLoader.vue')
const CartSuccess = () => import('@/views/CartSuccess.vue')
// const TestBirds = () => import('@/views/TestBirds.vue')
const Allcop = () => import('@/views/AllcopStart.vue')
const AllcopLogin = () => import('@/views/AllcopLogin.vue')
// const TestBirdsLogin = () => import('@/views/TestBirdsLogin.vue')
const DM = () => import('@/views/DM.vue')
const InfoPlus = () => import('@/views/InfoPlusStart.vue')
const InfoPlusLogin = () => import('@/views/InfoPlusLogin.vue')
const DMLogin = () => import('@/views/DMLogin.vue')
const HomeComponent = import.meta.env.VITE_E2_DM ? DM : import.meta.env.VITE_E2_INFOPLUS ? InfoPlus : Allcop
const LoginComponent = import.meta.env.VITE_E2_DM ? DMLogin : import.meta.env.VITE_E2_INFOPLUS ? InfoPlusLogin : AllcopLogin
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeComponent
    },
    {
      path: '/login',
      name: 'login',
      component: LoginComponent
    },
    {
      path: '/editor',
      name: 'editor',
      component: EditorLoader,
      meta: {
        themeId: '71d7bfac-4203-48ff-89e8-15dc00898752' // test-theme
      }
    },
    {
      path: '/mobile',
      meta: {
        mobile: true,
        themeId: '71d7bfac-4203-48ff-89e8-15dc00898752' // test-theme
      },
      component: EditorLoader,
      name: 'mobileEditor'
    },
    {
      path: '/success',
      name: 'success',
      component: CartSuccess
    }
  ]
})

export default router
